import * as React from 'react'
import { FC, useMemo } from 'react'
import { useQuery } from 'react-query'
import { IOption, IProviderProps } from '@user/components/Filters'
import { useGetBranchListOnMount } from '@user/store/branches/hooks/useGetBranchListOnMount'
import { useSelector } from 'react-redux'
import { selectAllBranches } from '@user/store/branches/slice'
import { get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'

export const BranchProvider: FC<IProviderProps> = ({ render }) => {
  // fetch full list
  const branchStatus = useGetBranchListOnMount()
  const allBranches = useSelector(selectAllBranches)

  // fetch distinct list
  const { data: distinctIds, isFetching } = useQuery(
    ['filters', 'draftLead', 'branch'],
    async () => {
      const response = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.filters(
          'draftLeads',
          'BranchId',
        )}`,
      )

      const ids: string[] = await response.json()
      return ids.filter(Boolean)
    },
  )

  const loading = isFetching || branchStatus === 'pending'

  const distinctBranches: IOption[] = useMemo(() => {
    if (!!distinctIds) {
      const options: IOption[] = allBranches
        .filter((b) => distinctIds.includes(b.id))
        .map((b) => ({ value: b.id, label: b.name }))
      return options
    }
    return []
  }, [allBranches, distinctIds])

  return <>{render(distinctBranches, loading)}</>
}
BranchProvider.displayName = 'BranchProvider'
